import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type AttachDocumentToLawyerMessageMutationVariables = Types.Exact<{
  messageId: Types.Scalars['Int']
  documentId: Types.Scalars['Int']
}>

export type AttachDocumentToLawyerMessageMutation = {
  __typename?: 'Mutation'
  attachDocumentToLawyerMessage: { __typename?: 'Message'; id: number }
}

export const AttachDocumentToLawyerMessageDocument = gql`
  mutation AttachDocumentToLawyerMessage($messageId: Int!, $documentId: Int!) {
    attachDocumentToLawyerMessage(messageId: $messageId, documentId: $documentId) {
      id
    }
  }
`
export type AttachDocumentToLawyerMessageMutationFn = ApolloReactCommon.MutationFunction<
  AttachDocumentToLawyerMessageMutation,
  AttachDocumentToLawyerMessageMutationVariables
>
export function useAttachDocumentToLawyerMessageMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AttachDocumentToLawyerMessageMutation,
    AttachDocumentToLawyerMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AttachDocumentToLawyerMessageMutation,
    AttachDocumentToLawyerMessageMutationVariables
  >(AttachDocumentToLawyerMessageDocument, options)
}
export type AttachDocumentToLawyerMessageMutationHookResult = ReturnType<
  typeof useAttachDocumentToLawyerMessageMutation
>
export type AttachDocumentToLawyerMessageMutationResult =
  ApolloReactCommon.MutationResult<AttachDocumentToLawyerMessageMutation>
export type AttachDocumentToLawyerMessageMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AttachDocumentToLawyerMessageMutation,
  AttachDocumentToLawyerMessageMutationVariables
>
